import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";
import type { IconName } from "@frontend/components/atoms/Icon";

import { Badge } from "./Badge";
import { type BadgeDataProps, badgeDataSchema } from "./Badge.schema";
import { BADGE_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [BADGE_TAG_NAME]: { props: BadgeDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-badge": HTMLElement;
  }
}

function RWCBadge({ icon, ...props }: BadgeDataProps): JSX.Element {
  return <Badge {...props} icon={icon as IconName | undefined} />;
}

componentManager.register(
  rwc(BADGE_TAG_NAME, {
    component: RWCBadge,
    dataSchema: badgeDataSchema,
  }),
);
